<template>
  <div class="main-container">
    <HeaderSoftware />
    <HeroSoftware />
    <BrandLogoCarousel />

    <div class="feature-icon-list-area section-space--pb_120 section-space--mt_40" id="about">
      <div class="container">
        <div class="section-title-wrapper text-center section-space--mb_100">
          <h2 class="section-title mb-30 wow move-up">¿Quiénes somos?</h2>
          <div class="text">
            Creamos soluciones digitales que integran <b>tecnología</b>, diseño e <b>innovación</b> para transformar tus
            procesos,
            <b>fortalecer la experiencia</b> del cliente y potenciar el <b>crecimiento de tu negocio.</b>
          </div>
        </div>
      </div>
      <FeatureList />
    </div>

    <TabTwo BgGradient="bg-gradient" />

    <Portafolio />

    <ContactForm />

    <ModalAP v-if="avisoPrivacidadModal" @close="avisoPrivacidadModal = false" />
    <ModalMV v-if="misionVisionModal" @close="misionVisionModal = false" />

    <FooterMain @openModal="avisoPrivacidadModal = true" />

    <OffcanvasSearchBox />
    <div class="whatsapp-container">
      <a
        href="https://api.whatsapp.com/send?phone=+524431371292&text=Hola,%20me%20gustar%C3%ADa%20cotizar%20un%20proyecto%20de%20software.%20%C2%BFPodr%C3%ADas%20brindarme%20informaci%C3%B3n?"
        target="_blank" aria-label="WhatsApp" rel="noopener noreferrer"
      >
        <div class="whatsapp-btn">
          <img src="https://cdn-icons-png.flaticon.com/512/1384/1384023.png" alt="Contactar por WhatsApp" loading="lazy"
            decoding="async" width="38" height="38" />
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import HeaderSoftware from '@/components/HeaderSoftware.vue'
import HeroSoftware from '@/components/HeroSoftware.vue'
import BrandLogoCarousel from '@/components/BrandLogoCarousel.vue'
import FeatureList from '@/components/FeatureList.vue'
import TabTwo from '@/components/TabTwo.vue'
import FooterMain from '@/components/FooterMain.vue'
import OffcanvasSearchBox from '@/components/OffcanvasSearchBox.vue'
import ContactForm from '@/components/ContactForm.vue'
import Portafolio from '@/components/Portafolio.vue'
import ModalAP from '@/components/modals/AvisoPrivacidad.vue'
import ModalMV from '@/components/modals/MisionVision.vue'

const BASE_URL = 'https://leonix.com.mx'
const OFFSET = 80

export default {
  name: 'HomeSoftwarePage',
  components: {
    HeaderSoftware,
    HeroSoftware,
    BrandLogoCarousel,
    FeatureList,
    TabTwo,
    FooterMain,
    OffcanvasSearchBox,
    ContactForm,
    Portafolio,
    ModalAP,
    ModalMV,
  },
  data: () => ({
    avisoPrivacidadModal: false,
    misionVisionModal: false,
  }),
  watch: {
    $route: {
      handler(to) {
        this.scrollToRouteSection(to)
      },
      immediate: true,
    },
  },
  methods: {
    scrollToRouteSection(route) {
      const hash = route.hash || (route.meta && route.meta.sectionHash)
      if (!hash) return

      this.$nextTick(() => {
        const target = document.querySelector(hash)
        if (!target) return

        const top = target.getBoundingClientRect().top + window.pageYOffset - OFFSET
        window.scrollTo({
          top,
          behavior: 'smooth',
        })
      })
    },
  },
  metaInfo() {
    const pageTitle =
      (this.$route.meta && this.$route.meta.pageTitle) ||
      'Leonix | Soluciones Digitales y Desarrollo de Software'
    const canonical =
      this.$route.path === '/' ? BASE_URL : `${BASE_URL}${this.$route.path}`

    return {
      title: pageTitle,
      htmlAttrs: {
        lang: 'es-MX',
      },
      link: [
        {
          rel: 'canonical',
          href: canonical,
        },
      ],
    }
  },
}
</script>

<style scoped>
.float-button-wrapper {
  position: fixed;
  z-index: 20;
  right: 30px;
  bottom: 30px;
}

.pulse {
  box-shadow: 0 0 0 rgba(92, 168, 44, 0.4);
  animation: pulse 2s infinite;
}

img.float-button {
  width: 60px;
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(92, 168, 44, 0.5);
    box-shadow: 0 0 0 0 rgba(92, 168, 44, 0.4);
  }

  70% {
    -moz-box-shadow: 0 0 0 10px rgba(92, 168, 44, 0);
    box-shadow: 0 0 0 30px rgba(92, 168, 44, 0);
  }

  100% {
    -moz-box-shadow: 0 0 0 0 rgba(92, 168, 44, 0);
    box-shadow: 0 0 0 0 rgba(92, 168, 44, 0);
  }
}

.rounded-circle {
  border-radius: 50% !important;
}

.whatsapp-container {
  position: fixed;
  bottom: 25px;
  right: 25px;
  z-index: 99999;
}

.whatsapp-btn {
  width: 70px;
  height: 70px;
  background: #25d366;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: transform .25s ease;
  animation: pulse 2s infinite;
}

.whatsapp-btn img {
  width: 38px;
  height: 38px;
}

.whatsapp-btn:hover {
  transform: scale(1.1);
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.4);
  }

  70% {
    box-shadow: 0 0 0 18px rgba(37, 211, 102, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
}

.visually-hidden {
  position: absolute;
  left: -9999px;
}
</style>
